import { Title } from '@radix-ui/react-dialog';
import { PropsWithChildren } from 'react';

import styles from './modal-components.module.css';

type ModalTitleProps = PropsWithChildren;

export const ModalTitle = ({ children }: ModalTitleProps) => (
  <Title asChild>
    <h1 className={styles.title}>{children}</h1>
  </Title>
);
